<template>
  <div>
    <Modal v-model="isShowModal" title="充值记录" @on-cancel="hide('formValidate')" :mask-closable="false">
      <Table :columns="columns" :data="data" size="small" :stripe="true">
        <template slot-scope="{ row, index }" slot="isDisable">
          <Tag color="green" v-if="row.isDisable === 0" size="default">启用</Tag>
          <Tag color="volcano" v-if="row.isDisable === 1" size="default">禁用</Tag>
        </template>
      </Table>

      <!-- 重写对话框底部按钮 -->
      <div slot="footer">
        <Button @click="hide('formValidate')">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "tenant-ope",
  props: ['regionList'],
  data() {
    return {
      isShowModal: false,
      loadingBtn: false,
      params: {
        page: 1,
        rows: 10,
        tenantId: '',
        changeType: 1
      },
      data: [],
      total: 0,
      columns: [
        {
          title: '充值时间',
          minWidth: 150,
          key: 'createTime'
        },
        {
          title: '标题',
          minWidth: 120,
          key: 'title'
        },
        {
          title: '充值金额',
          minWidth: 100,
          key: 'changeAmount'
        },
        {
          title: '充值后余额',
          minWidth: 100,
          key: 'afterAmount'
        },
      ],
    }
  },
  methods: {
    // 显示模态框
    show(row) {
      this.isShowModal = true;
      this.params.tenantId = row.tenantId
      this.findRecordList();
    },
    // 管理员-列表查询
    findRecordList() {
      this.axios.post('/tenant/capitalRecord', this.params).then(res => {
        console.log(res);
        if (res.status == 200) {
          this.total = res.data.total;
          this.data = res.data.rows;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询加盟商列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 关闭模态框
    hide(name) {
      this.isShowModal = false;
      this.params.tenantId = '';
      // this.$refs[name].resetFields();
    }
  }
}
</script>

<style scoped>

</style>